/** Contact group types stored in `contact_group.group_type`. */
export type ContactGroupType =
  | 'email'
  | 'whatsapp'
  | 'call'
  | 'both'
  | 'email_call'
  | 'whatsapp_call'
  | 'all';

export type CampaignChannelType = 'email' | 'whatsapp' | 'call';

const EMAIL_TYPES: ContactGroupType[] = ['email', 'both', 'email_call', 'all'];
const WHATSAPP_TYPES: ContactGroupType[] = ['whatsapp', 'both', 'whatsapp_call', 'all'];
const CALL_TYPES: ContactGroupType[] = ['call', 'email_call', 'whatsapp_call', 'all'];

function normalizeGroupType(groupType?: string | null): ContactGroupType | '' {
  if (!groupType) {
    return '';
  }
  return String(groupType).trim().toLowerCase() as ContactGroupType;
}

export function contactGroupIncludesEmail(groupType?: string | null): boolean {
  const type = normalizeGroupType(groupType);
  return !type || EMAIL_TYPES.includes(type);
}

export function contactGroupIncludesWhatsapp(groupType?: string | null): boolean {
  const type = normalizeGroupType(groupType);
  return !type || WHATSAPP_TYPES.includes(type);
}

export function contactGroupIncludesCall(groupType?: string | null): boolean {
  const type = normalizeGroupType(groupType);
  return Boolean(type && CALL_TYPES.includes(type));
}

export function contactGroupSupportsCampaignType(
  groupType: string | null | undefined,
  campaignType: CampaignChannelType
): boolean {
  switch (campaignType) {
    case 'email':
      return contactGroupIncludesEmail(groupType);
    case 'whatsapp':
      return contactGroupIncludesWhatsapp(groupType);
    case 'call':
      return contactGroupIncludesCall(groupType);
    default:
      return false;
  }
}

export function filterContactGroupsByCampaignType(
  groups: any[],
  campaignType: CampaignChannelType
): any[] {
  return groups.filter((group) =>
    contactGroupSupportsCampaignType(group.group_type, campaignType)
  );
}

export const CONTACT_GROUP_TYPE_OPTIONS: { value: ContactGroupType; label: string }[] = [
  { value: 'email', label: 'Email' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'call', label: 'Call' },
  { value: 'both', label: 'Email & WhatsApp' },
  { value: 'email_call', label: 'Email & Call' },
  { value: 'whatsapp_call', label: 'WhatsApp & Call' },
  { value: 'all', label: 'Email, WhatsApp & Call' },
];
